"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentRetrievalQueryOutputSchema = exports.documentRetrievalHybridQueryInputSchema = exports.documentRetrievalVectorQueryInputSchema = exports.documentRetrievalLexicalQueryInputSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.documentRetrievalLexicalQueryInputSchema = zod_1.z.object({
    fileId: zod_1.z.string(),
    ocrPresetName: cadstrom_shared_1.OcrPresetNameSchema,
    chunkingPresetName: cadstrom_shared_1.ChunkingPresetNameSchema,
    indexName: cadstrom_shared_1.LexicalIndexNameSchema,
    queryText: zod_1.z.string(),
    topK: zod_1.z.number().int().positive().default(10),
    options: cadstrom_shared_1.LexicalSearchOptionsSchema.optional(),
    searchProvider: cadstrom_shared_1.SearchProviderNameSchema.optional().default(cadstrom_shared_1.SearchProviderName.OpenSearch),
});
exports.documentRetrievalVectorQueryInputSchema = zod_1.z.object({
    fileId: zod_1.z.string(),
    ocrPresetName: cadstrom_shared_1.OcrPresetNameSchema,
    chunkingPresetName: cadstrom_shared_1.ChunkingPresetNameSchema,
    embeddingPresetName: cadstrom_shared_1.EmbeddingPresetNameSchema,
    queryText: zod_1.z.string(),
    topK: zod_1.z.number().int().positive().default(10),
    searchProvider: cadstrom_shared_1.SearchProviderNameSchema.optional().default(cadstrom_shared_1.SearchProviderName.OpenSearch),
});
exports.documentRetrievalHybridQueryInputSchema = zod_1.z.object({
    fileId: zod_1.z.string(),
    ocrPresetName: cadstrom_shared_1.OcrPresetNameSchema,
    chunkingPresetName: cadstrom_shared_1.ChunkingPresetNameSchema,
    embeddingPresetName: cadstrom_shared_1.EmbeddingPresetNameSchema,
    queryText: zod_1.z.string(),
    topK: zod_1.z.number().int().positive().default(10),
    options: cadstrom_shared_1.HybridSearchOptionsSchema.optional(),
    searchProvider: cadstrom_shared_1.SearchProviderNameSchema.optional().default(cadstrom_shared_1.SearchProviderName.OpenSearch),
});
exports.documentRetrievalQueryOutputSchema = zod_1.z.object({
    results: zod_1.z.array(cadstrom_shared_1.SearchResultSchema),
});
//# sourceMappingURL=document-retrieval.dto.js.map